export enum SalesDepositType {
  Standard = 'standard',
  CustomPercentage = 'custom-percentage',
  CustomAmount = 'custom-amount',
}
